import React, { useEffect } from "react";
import "./Einvoice.scss";
import FullScreenDialog from "../../commons/FullScreenDilog/FullScreenDilog";
import { TableHeader, TableLoader } from "../../commons";
import { EINVOICE_HEADERS } from "../../../constant/invoiceListConst";
import EinvoiceTableData from "./EinvoiceTableData";
import EinvoiceRevert, { REVERT_EINVOICE_OPTION } from "./EinvoiceRevert";
import { RedErrorIcon } from "../../../assets/images";
import { formatDate } from "../../../utils/commonFunctions";

type AppProps = {
  success: number | null;
  isOpen: boolean;
  data: any;
  fetching: boolean;
  eInvoiceAt: string | null;
  eInvoiceError: string;
  isEinvoicePresent: number ;
  togglePreviewEInvoice: (id?: string) => void;
  handleSubmitPreviewEinvoice: (type: string) => void;
  cancelComment: string;
  eInvoiceRadioValue: string;
  setCancelComment: (data: string) => void;
  setEinvoiceRadioValue: (data: string) => void;
  isCancelEInvoicePresent?:boolean;
  isGenerateEInvoicePresent?:boolean;
};

const EinvoiceModal = ({
  isOpen,
  data,
  success,
  eInvoiceAt,
  eInvoiceError,
  togglePreviewEInvoice,
  handleSubmitPreviewEinvoice,
  fetching,
  isEinvoicePresent,
  cancelComment,
  eInvoiceRadioValue,
  setCancelComment,
  setEinvoiceRadioValue,
  isGenerateEInvoicePresent,
  isCancelEInvoicePresent
}: AppProps) => {
  useEffect(() => {
    setCancelComment("");
    setEinvoiceRadioValue(REVERT_EINVOICE_OPTION[0]?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeHeaders = (name: string) => {
    switch (name) {
      case "total_assessable_value":
        return "Total Assessable";
      case "total_cgst_value":
        return "Total CGST";
      case "total_sgst_value":
        return "Total SGST";
      case "total_igst_value":
        return "Total IGST";
      case "total_discount":
        return "Total Discount";
      case "total_invoice_value":
        return "Total Invoice";
      case "number_of_item":
        return "Number of Item";
      case "document_type":
        return "Document Type";
      case "document_number":
        return "Document Number";
      case "document_date":
        return "Document Date";
      case "address1":
        return "Address 1";
      case "address2":
        return "Address 2";
      case "legal_name":
        return "Legal Name";
      case "trade_name":
        return "Trade Name";
      case "location":
        return "Location";
      case "pincode":
        return "Pin Code";
      case "gstin":
        return "GSTIN";
      case "state_code":
        return "State Code";
      case "email":
        return "Email";
      case "phone_number":
        return "Phone Number";
      case "item_serial_number":
        return "Serial No.";
      case "product_description":
        return "Product Description";
      case "unit":
        return "Unit";
      case "place_of_supply":
        return "Place of Supply";
      case "quantity":
        return "Quantity";
      case "hsn_code":
        return "Hsn Code";
      case "discount":
        return "Discount";
      case "unit_price":
        return "Unit Price";
      case "total_amount":
        return "Total Amount";
      case "assessable_value":
        return "Assessable Value";
      case "gst_rate":
        return "Gst Rate";
      case "igst_amount":
        return "IGST Amount";
      case "sgst_amount":
        return "SGST Amount";
      case "cgst_amount":
        return "CGST Amount";
      case "total_item_value":
        return "Total Item Value";
      case "is_service":
        return "Service";

      default:
        return name;
    }
  };

  const createRows = (data: any, obj: any) => {
    let rowCreated = data?.map((item: any) => {
      return (
        <div className="one-input">
          <div className="inside-row-e-invoice">{changeHeaders(item)}</div>
          <div className="row-einvoice">
            {obj[item]
              ? item === "document_date"
                ? formatDate(obj[item])
                : obj[item]
              : "--"}
          </div>
        </div>
      );
    });
    return rowCreated;
  };


  const EinvoiceModalBody = () => {
    return data?.id ? (
      <div className="e-invoice">
        {/* {!!data?.invoice_pdf_url && <div className="flex" style={{alignItems:"flex-end"}}> <a className="btn btn-primary mb-2 ml-4" href={data?.invoice_pdf_url}>Download E-invoice Pdf</a></div>} */}
        <div
          className={
            isEinvoicePresent === 1 || isEinvoicePresent === 2 || eInvoiceError?.length 
              ? "reverse-einvoice"
              : ""
          }
        >
        
          {/* left side preview  */}
  
            <div
              style={
                isEinvoicePresent === 1 || isEinvoicePresent === 2 || eInvoiceError?.length 
                  ? { width: "60%" }
                  : {}
              }
            >
                {((isEinvoicePresent === 1 || isEinvoicePresent === 2) && !!data?.irn?.length) ? <div className="ml-4 mt-1 mb-1 irn"> <span style={{fontWeight:"500"}}>IRN NO </span> : {data?.irn}</div>  : null}
              {/* value_details */}
              <div className={"sub-heading-e-invoice"}>VALUE DETAILS</div>

              {data?.value_details ? (
                <div
                  className={
                    isEinvoicePresent === 1 || isEinvoicePresent === 2 || eInvoiceError?.length 
                      ? "inside-einvoice-reverse"
                      : "inside-einvoice"
                  }
                >
                  {createRows(
                    Object.keys(data?.value_details),
                    data?.value_details
                  )}
                </div>
              ) : null}

              {/* document  */}
              <div className={"sub-heading-e-invoice"}>DOCUMENT DETAILS</div>
              {data?.document_details ? (
                <div
                  className={
                    isEinvoicePresent === 1 || isEinvoicePresent === 2 || eInvoiceError?.length 
                      ? "inside-einvoice-reverse"
                      : "inside-einvoice"
                  }
                >
                  {createRows(
                    Object.keys(data?.document_details),
                    data?.document_details
                  )}
                </div>
              ) : null}

              {/* buyer Details  */}
              <div className={"sub-heading-e-invoice"}>SELLER DETAILS</div>
              {data?.seller_details ? (
                <div
                  className={
                    isEinvoicePresent === 1 || isEinvoicePresent === 2 || eInvoiceError?.length 
                      ? "inside-einvoice-reverse"
                      : "inside-einvoice"
                  }
                >
                  {createRows(
                    Object.keys(data?.seller_details),
                    data?.seller_details
                  )}
                </div>
              ) : null}

              {/* seller Details  */}
              <div className={"sub-heading-e-invoice"}>BUYER DETAILS</div>
              {data?.buyer_details ? (
                <div
                  className={
                    isEinvoicePresent === 1 || isEinvoicePresent === 2 || eInvoiceError?.length 
                      ? "inside-einvoice-reverse"
                      : "inside-einvoice"
                  }
                >
                  {createRows(
                    Object.keys(data?.buyer_details),
                    data?.buyer_details
                  )}
                </div>
              ) : null}

              {/* item list  */}
              <div className={"sub-heading-e-invoice"}>ITEM DETAILS</div>
              {data?.item_list?.length ? (
                <div
                  className={"inside-einvoice-items"}
                  style={{ overflowX: "scroll" }}
                >
                  <table className="table thead-light table-bordered ml-4">
                    <thead className="text-left no-wrap sticky-table-header">
                      <TableHeader tableHeader={EINVOICE_HEADERS} />
                    </thead>
                    <tbody>
                      <EinvoiceTableData
                        tableHeaders={EINVOICE_HEADERS}
                        data={data?.item_list}
                      />
                    </tbody>
                  </table>
                </div>
              ) : null}
            </div>
          

          {/* comment box  */}
          {(isEinvoicePresent === 1 || isEinvoicePresent === 2 || eInvoiceError?.length ) && (
            <div
              style={
                isEinvoicePresent === 1 || isEinvoicePresent === 2 || eInvoiceError?.length 
                  ? { width: "40%" }
                  : {}
              }
            >
              {eInvoiceError?.length ? (
            <div className="p-2" style={{ marginLeft: "40px",border:"1px solid #ba4916" }}>
              {eInvoiceError?.split("||")?.map((item: any) => {
                return (
                  <div className="mt-2 mb-2 error-msg">
                    <span className="mr-1">
                      <img src={RedErrorIcon} alt="error" />
                    </span>
                    <span className="ml-2">{item}</span>
                  </div>
                );
              })}
            </div>
          ) : <EinvoiceRevert
                data={data}
                eInvoiceAt={eInvoiceAt}
                cancelComment={cancelComment}
                radioValue={eInvoiceRadioValue}
                isEinvoicePresent={isEinvoicePresent}
                setCancelComment={setCancelComment}
                setRadioValue={setEinvoiceRadioValue}
              />
            }
            </div>
          )}
        </div>
      </div>
    ) : (
      <TableLoader Rows={10} ColumnPerRow={5} />
    );
  };

  return (
    <div>
      <FullScreenDialog
        error={eInvoiceError}
        success={success}
        downloadBtn={{ url: data?.invoice_pdf_url, name: "E-Invoice Pdf" }}
        onClose={togglePreviewEInvoice}
        loading={fetching}
        title={eInvoiceError?.length ? "Errors In E-Invoice" : "View E-Invoice"}
        body={EinvoiceModalBody}
        disabled={
          !isOpen ||
          ((isEinvoicePresent === 1 || isEinvoicePresent === 2) &&
            !cancelComment?.length)
        }
        closeAfterLoading={
          isEinvoicePresent === 1 || isEinvoicePresent === 2
            ? "cancelling..."
            : "sending..."
        }
        saveBtn={
          isEinvoicePresent === 1 &&  
          (!!eInvoiceAt ? !(+new Date(eInvoiceAt)?.getTime() +  86400000 < +new Date()) : true)
            ? (isCancelEInvoicePresent ? "Cancel E-Invoice":"")
            : isEinvoicePresent === 2 || ( eInvoiceError?.length ||
              (!!eInvoiceAt &&
                (+new Date(eInvoiceAt)?.getTime() +  86400000 < +new Date())))
            ? (isGenerateEInvoicePresent ? "Send E-Invoice" : "")
            :  isGenerateEInvoicePresent ? "Send E-Invoice" : ""
        }
        onSubmit={() =>
          handleSubmitPreviewEinvoice(
            isEinvoicePresent === 1 ? "revert" : "submit"
          )
        }
      />
    </div>
  );
};

export default EinvoiceModal;
